import { getSCVisitorId } from '../analytics/dtm_helper';
import BaseModel from './base.model';
import LeadAdapter from '../adapters/lead.adapter';

export default class Lead extends BaseModel {
  static endpoint = 'leads.json';

  static adapter = LeadAdapter;

  sc_visitor_id = getSCVisitorId();

  first_name = '';

  last_name = '';

  email = '';

  phone = '';

  address = '';

  city = '';

  state = '';

  zip = '';

  comments = '';

  campaign_name = '';

  promotion = '';

  agent_number = '';

  // Advisor.id (or agentNumber / dsbNum)
  age = '';

  goal = '';

  income_range = '';

  wealth_range = '';

  page_url = '';

  utm_source = '';

  utm_medium = '';

  utm_campaign = '';

  utm_term = '';

  utm_content = '';

  recaptcha_response_token = '';

  zodiac_matching_id = '';

  promiseFetch (options = {}) {
    throw new Error('fetch is not allowed on leads');
  }

  promiseSave (options = {}) {
    throw new Error('save is not allowed on leads');
  }

  promiseDestroy (options = {}) {
    throw new Error('destroy is not allowed on leads');
  }
}
